<app-header></app-header>
<div class="rounded-2xl border border-[#E4E7EC] flex flex-col w-full relative mb-4 h-[calc(100%-90px)]">
  <div class="flex h-full overflow-y-auto no-scrollbar flex-col bg-white rounded-2xl shadow w-full">
    <form [formGroup]="form">
      <div class="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-4 gap-6 p-6 pb-24">
        <app-select-input label="University" class="w-full md:col-span-2" [is_required]="true" formControlName="university_id" [options]="ds.dropdown_list?.university_list"></app-select-input>
        <app-select-input label="Batch" class="w-full md:col-span-2" [is_required]="true" formControlName="academic_year_id" [options]="ds.dropdown_list?.academic_list"></app-select-input>
        <app-text-input class="w-full md:col-span-2" type="text" [is_required]="true" [label]="'First Name'" formControlName="first_name"></app-text-input>
        <app-text-input class="w-full md:col-span-2" type="text" [is_required]="true" [label]="'Last Name'" formControlName="last_name"></app-text-input>
        <app-text-input class="w-full md:col-span-2" [is_required]="true" [label]="'Email'" formControlName="email"></app-text-input>
        <app-text-input class="w-full md:col-span-2" type="number" [label]="'Contact Number'" formControlName="contact"></app-text-input>
        <app-text-input class="w-full md:col-span-2" [is_required]="true" [label]="'Unique ID'" formControlName="registration_number"></app-text-input>
        <div class="w-full md:col-span-2">
          <ng-container *ngIf="showPasswordField">
            <app-text-input [mask]="true" type="password" [is_required]="true" class="w-full" [label]="'Password'" formControlName="password"></app-text-input>
          </ng-container>
          <div *ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)">
            <small class="text-red-500" *ngIf="form.get('password')?.errors?.['pattern']">
              (Min 8 chars, 1 Uppercase, 1 Number, 1 Special Char)
            </small>
          </div>
        </div>
      </div>
    </form>
    <div class="flex absolute rounded-b-2xl px-6 py-4 items-center justify-between w-full bottom-0 bg-white border-t border-gray-100">
      <div>
        <app-button *ngIf="selected_item?.id && !showPasswordField" color="border-primary text-primary" label="Reset Password" type="button" (click)="resetPassword()"></app-button>
      </div>
      <div class="flex items-center gap-4">
        <app-button color="border-gray-300 text-gray-700 font-medium" label="Discard" type="button" (click)="discard()"></app-button>
        <app-button color="bg-primary text-white" [label]="selected_item?.id ? 'Update' : '+ Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
      </div>
    </div>
  </div>
</div>
